 export class Gender {
	 /** BLANK="" */
	readonly BLANK : string = "";
	/** MALE="1" */
	readonly MALE : string = "1";
	/** FEMALE="2" */
    readonly FEMALE : string = "2";
 }